import { Layout } from "antd";

export function HeaderToGlobalLayout(): JSX.Element {
  return (
    <Layout.Header
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        borderBottom: "1px solid lightgray",
        backgroundColor: "#1d8ff3",
      }}
    >
      <img
        src="https://heru-static-assets.s3.us-east-2.amazonaws.com/logo-heru-white.svg"
        alt="heru logo"
        style={{ width: 60 }}
      />
    </Layout.Header>
  );
}
